// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1lK6f","footer":"ModalInfo_footer__3WtKB"};